export const bookingSchema = {
	title: 'booking schema',
	version: 5,
	primaryKey: 'bookingId',
	type: 'object',
	properties: {
		bookingCode: { type: 'string' },
		bookingId: {
			type: 'string',
			maxLength: 70,
			//example: 20228Z5F3J6S
		},
		bookingLegId: {
			type: 'string',
		},
		isCheckedIn: {
			type: 'boolean',
		},
		bookingState: {
			type: 'string',
			// enum:  NEW | EXECUTING | FINISHED | CANCELLED_BY_DISTRIBUTOR | CANCELLED_BY_PASSENGER | CANCELLED_NO_SHOW
		},
		passengerList: {
			type: 'array',
			items: {
				type: 'object',
				properties: {
					firstName: { type: 'string' },
					lastName: { type: 'string' },
					phone: { type: 'string' },
					email: { type: 'string' },
					isMainPassenger: { type: 'boolean' },
					specialNeeds: {
						type: 'string',
						// NONE, WHEELCHAIR_TYPE_1, WHEELCHAIR_TYPE_2
					},
				},
			},
		},
		specialNeeds: {
			type: 'string',
			// NONE, WHEELCHAIR_TYPE_1, WHEELCHAIR_TYPE_2
		},
		paymentAmount: { type: 'number' },
		currencyCode: {
			type: 'string',
			// EUR
		},
		paymentForm: {
			type: 'string',
			// CASH, DIGITAL
		},
		paymentState: {
			type: 'string',
			// enum TO_PAY, INVOICE_SEND, PAID, FAILED
		},
		checkedInScheduledLegs: {
			type: 'array',
			items: {
				type: 'object',
				properties: {
					isCheckedIn: {
						type: 'boolean',
					},
					scheduledLegId: {
						type: 'string',
					},
				},
			},
		},
		pricings: {
			type: 'array',
			items: {
				type: 'object',
				additionalProperties: true,
			},
		},
		toddlerSeats: {
			type: 'number',
		},
		extraSeatsAvailable: {
			type: 'number',
		},
		bulkyLuggage: {
			type: 'boolean',
		},
		additionalProperty: {
			type: 'object',
		},
	},
	required: ['bookingId', 'bookingCode'],
};
